import 'moment/locale/fi';
import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { bindActionCreators } from 'redux';
import { v1 as uuidv1 } from 'uuid';
import { requestSaveTask } from '../../actions/task';
import { getLocalizedString } from '../../localization/LocalizedString';
import Button from '../forms/Button';
import Select from '../forms/Select';
import TextArea from '../forms/TextArea';
import './ManualTask.css';
import TimePicker from '../../views/24hTimePicker/TimePicker';

class ManualTask extends React.Component {
  constructor(props) {
    super(props);
    this.requestId = uuidv1();
    this.taskId = uuidv1();
    this.state = {
      startTime: '',
      endTime: '',
      editStartDate: null,
    };
  }

  onSubmit(evt) {
    evt.preventDefault();
    const formData = new FormData(evt.target);
    const { startTime, endTime, start } = this.state;
    const data = {
      requestId: this.requestId,
      taskId: this.taskId,
      sequenceNumber: 0,
      destinationId: this.props.destination.id,
      serviceSiteId: this.props.serviceSite.id,
      taskType: 'manual',
    };

    for (const [key, value] of formData.entries()) {
      data[key] = value;
    }
    const startDate = new Date(startTime);
    const endDate = new Date(endTime);

    const taskStartTime = `${startDate.getHours()}:${startDate.getMinutes()}`;
    const taskEndTime = `${endDate.getHours()}:${endDate.getMinutes()}`;

    data.startTime = moment(`${start} ${taskStartTime}`).toDate();
    data.endTime = moment(`${start} ${taskEndTime}`).toDate();
    const { requestSaveTask, translate } = this.props;
    if (start !== undefined) {
      requestSaveTask(JSON.stringify(data), (e) => {
        console.log(e);
        toast.error(translate('new_task.save_failed'));
      },
      () => this.props.onSaved());
    } else {
      this.setState({ editStartDate: null });
    }
  }

  getServiceOptions() {
    const { currentLanguage, serviceSite } = this.props;
    const { services } = serviceSite || {};

    return (services || []).map((service) => ({
      value: service.id,
      text: getLocalizedString(service.name, currentLanguage),
    }));
  }

  onHandleChange24hTimePicker = (evt) => {
    if (evt.isStartTime) {
      this.setState({ startTime: evt.pickedTime });
    } else {
      this.setState({ endTime: evt.pickedTime });
    }
  };

  taskDateChange = (editStartDate) => {
    this.setState({
      editStartDate,
      start: editStartDate ? moment(editStartDate).format('YYYY-MM-DD') : undefined,
    });
  };

  render() {
    const { translate, currentLanguage } = this.props;
    const { editStartDate } = this.state;
    return (
      <form className="service-site-form" onSubmit={this.onSubmit.bind(this)}>

        <div>
          <div className="row">
            <div className="col-sm-12">
              <h1>{translate('new_task.title')}</h1>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <Select
                name="serviceId"
                data={this.getServiceOptions()}
                placeholder={this.props.translate('new_task.service_placeholder')}
                required />
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 col-md-12">
              <div className="row">
                <div className="col-sm-12"><h2>{translate('new_task.date')}</h2></div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <DatePicker
                    name="date"
                    className="app-date-picker-input"
                    selected={editStartDate}
                    onChange={this.taskDateChange}
                    dateFormat={['dd.MM.yyyy', 'd.M.yyyy', 'dd.M.yyyy', 'd.MM.yyyy']}
                    strictParsing
                    locale={currentLanguage === 'fi' ? 'fi' : 'en'}
                    placeholderText="DD.MM.YYYY"
                    popperClassName="app-date-picker-popper"
                    portalId="app-date-picker-portal"
                    showPopperArrow={false}
                    required />
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-12 time-picker-24h-block">
              <div className="row">
                <div className="col-sm-12"><h2>{translate('new_task.start_stop_time')}</h2></div>
              </div>
              <div className="row">
                <div className="col-xs-9">
                  <TimePicker name="start"
                              selectedTime={this.onHandleChange24hTimePicker}
                              required
                              stepValue={0}
                              isStartTime />
                </div>
                <div className="time-selector-seperator"><span>&mdash;</span></div>
                <div className="col-xs-9 end-24h-time-picker">
                  <TimePicker name="end"
                              selectedTime={this.onHandleChange24hTimePicker}
                              required
                              stepValue={0}
                              isStartTime={false} />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h2>{translate('new_task.description')}</h2>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <TextArea name="taskInfo" rows={10} placeholder={translate('new_task.description_placeholder')} />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <Button onClick={this.props.onCancel}>{translate('form.reset')}</Button>
            </div>
            <div className="col-sm-6">
              <Button>{translate('form.submit')}</Button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  const activeLang = getActiveLanguage(locale);

  return {
    translate: getTranslate(locale),
    currentLanguage: (activeLang && activeLang.code) || 'fi',
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  requestSaveTask,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManualTask);
